import { types as sdkTypes } from './util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

export const SYDNEY = {
  address: 'Sydney NSW, Australia',
  origin: new LatLng(-33.8688197, 151.2092955),
  bounds: new LatLngBounds(
    new LatLng(-33.578140996, 151.343020992),
    new LatLng(-34.118344992, 150.520928608)
  ),
};